export default __webpack_public_path__ + "static/media/element_23.10e353e1.jpg";